import { Component } from '@angular/core';
import { NavController, NavParams
         ,ToastController, AlertController,LoadingController  } from 'ionic-angular';
import { HttpClient,HttpResponse } from '@angular/common/http';

// types
import { RegisterViewModel,LocationList } from '../model/types';

//service
import { AppSharedService } from '../service/app_shared';

//page
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})

export class RegisterPage {

  //class variable
  name:string;
  mobile:string;
  email:string;
  location:number;
  password:string;
  refmobileno:string;
  locationList:LocationList[];
  //constructor

  //constructor
  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , public toastCtrl: ToastController
    , public alertCtrl: AlertController
    , private http: HttpClient
    , public appSharedService:AppSharedService
    , public loadingCtrl : LoadingController
  ) {

    //initialize constrctor variable
     this.name="";
    this.mobile="";
    this.email="";
    this.password="";
    this.locationList=[];
    this.location=0;
    this.refmobileno="";
    this.getLocationList();
  }

  // do the login
  doLogin(){
    this.navCtrl.setRoot(LoginPage);
  }

  getLocationList(){
  
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    // show loader
    loading.present();

          // set the url
    var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+"/"+this.appSharedService.configInfo.urlInfo.urlGetLocationList)
      
    // do the service call
    this.http.get(url,{observe:'response'})
    .subscribe((res: HttpResponse<any>) => {   
      if(res.status==200){
        if(res.body!=undefined && res.body!=null){
               this.locationList=  res.body as LocationList[];
               loading.dismiss();
        }
      }else{
        loading.dismiss();
      }
    }) 
  }
   
  // do the register
  doRegister(){

        //create loader
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });

    if(this.validateRegister())
    {
      // se the view model
      var reg:RegisterViewModel={
                PhoneNumber: this.mobile,
                Password:this.password,
                LocationId:this.location,
                CustomerName:this.name,
                Email:this.email,
                RefContactNumber:this.refmobileno
      };

      // set the url
      var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+"/"+this.appSharedService.configInfo.urlInfo.urlRegisterUser)
      
      //show the loader
      loading.present();

      //do the service call
      this.http.post(url, reg, {observe: 'response'})
      .subscribe((res: HttpResponse<any>) => {   
        if(res.status==200){
         
          let message=this.appSharedService.getHttpResponseMessage(res,'You have regster successfully to Kuberdeals.You can login once admin approve your account!');
          //dismiss the loader
          loading.dismiss();

          // show success message
          this.alertCtrl.create({
            title: 'Success!',
            subTitle: message,
            buttons: ['OK']
          }).present();
          
          // clear form
          this.clearForm();
          
          // route to login page
          this.navCtrl.setRoot(LoginPage);
        }else{ 
          
          //dismiss the loader
          loading.dismiss();
          let message=this.appSharedService.getHttpResponseMessage(res,'Please enter valid details!');
          // show errrormessage
          this.alertCtrl.create({
            title: 'Error!',
            subTitle: message,
            buttons: ['OK']
          }).present();
        }
      });
     }
  }
  
  // clear form
  clearForm(){
    this.password="";
    this.name="";
    this.location=0;
    this.mobile="";
    this.email="";
  }
  validatePhone(num:string){
    var isValid=true;

    if(isNaN(Number(num))){
      isValid=false;
    }
    else{
      if (/^\d{10}$/.test(num)) {
            // value is ok, use it
        } else {
        isValid=false;
        }
    }
     return isValid;
   }

  // validate register page
  validateRegister(){
    if(this.name.trim()==""){
      this.toastCtrl.create({
        message: "Please enter your name",
        duration: 5000
      }).present();
      return false;
    }
    else if(this.validatePhone(this.mobile.trim())==false){
      this.toastCtrl.create({
        message: "Please enter correct 10 digit mobile number",
        duration: 5000
      }).present();
      return false;
    } 
    else if(this.location==0){
      this.toastCtrl.create({
        message: "select location",
        duration: 5000
      }).present();
      return false;
    } 
    else if(this.password.trim()==""){
      this.toastCtrl.create({
        message: "password is required",
        duration: 5000
      }).present();
      return false;
    }
    else if(this.refmobileno.trim()!=""){
      if(this.validatePhone(this.refmobileno.trim())==false){
        this.toastCtrl.create({
          message: "Please enter correct 10 digit reference mobile number",
          duration: 5000
        }).present();
        return false;
      }
    }
    
    return true
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts